import React, { useEffect, useState } from "react";
import tw from "tailwind-styled-components";
import { Link, useNavigate } from "react-router-dom";
import Images from "../Images";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Table from "../Components/Charges/Table";
import {
  Page,
  BoxContainer,
  BoxTitle,
  Underline,
} from "../Components/Styles/PageStyles";
import { Field, Form, Formik } from "formik";
import { useTranslation } from "react-i18next";
import {
  InputGroup,
  FieldWrapper,
  Label,
  FormContainer,
  SubmitBtn,
  PreviewBtn,
  FormContainerVertical,
  CombineInputGroup
} from "../Components/Styles/InputStyles.jsx";
import DropZone from "../Components/Dropzone";
import Loading from "../Components/Loading";
import { useMutation, useQuery } from "react-query";
import Config from "../Config";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { Update_User } from "../Redux/actions";
import SelectSearch from "react-select-search";
import "../select-search.css";
import Fuse from "fuse.js";
import UpdateStatusModel from "../Components/Charges/UpdateStatusModel";
import { ToastContainer, toast } from "react-toastify";
import Navbar from "../Components/Navbar";
import { MdPassword } from "react-icons/md";

const SetCharges = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [openUpdateModel, setOpenUpdateModel] = useState(false);
  const [selectedData, setSelectedData] = useState("");

  const [changePasswordModel, setChangePasswordModel] = useState(false);
  const [isInitialValueSaved, setIsInitialValueSaved] = useState(true);
  const user = useSelector((state) => state.UserReducer.user);
    // ----- Getting Initial Data ------
  const fetchFunction = async () => {
    const body = new FormData();
    body.append("token", user.email);
    body.append("userType", user.userType);
    body.append("type", 3);
    return await axios.post(`${Config.apiUrl}/getchargesnew`, 
    body, 
    {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const { isLoadingFetch, error, data, refetch, isRefetchingFetch } = useQuery(
    "GetChargess",
    fetchFunction
  );

  useEffect(()=>{
    // setTypeOfReg (data?.data?.data?.typeOfReg);
    // setTypeOfRegLabel (data?.data?.data?.typeOfRegLabel);
    // setTypeOfAssocLabel (data?.data?.data?.typeOfAssocLabel);
    // setRegionLabel (data?.data?.data?.regionLabel);
    // setDistrictLabel (data?.data?.data?.districtLabel);
    // SetDynamicAssociation (data?.data?.data?.typeOfReg);
    // SetDynamicDistricts (data?.data?.data?.region);
     setIsInitialValueSaved (false);
    // setGameLabel(data?.data?.data?.gameLabel);
  },[data])
  // change password


// update Charges
  const updateChargesFunction = async (values) => {
    const body = new FormData();
    
    body.append("email", user.email);
    body.append("registerAssoc", values.registerAssoc);
    body.append("correction", values.correction);
    body.append("changeArticle", values.changeArticle);
    body.append("changeName", values.changeName);
    body.append("changeAddress", values.changeAddress);
    body.append("lostCertificate", values.lostCertificate);
    body.append("annualFees", values.annualFees);
    body.append("misc", values.misc);

    return await axios.post(
    Config.apiUrl + "/updatecharges",
    body,
    {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  }

const onSuccess = (data) => {
  toast.success(data?.data?.msg, "Success");
};

const onError = (data) => {
  toast.error(data?.response?.data?.msg, "An Error Occured");
};

const { mutate: updateChargesMutate, isLoading: isLoading } =
  useMutation(updateChargesFunction, {
    onSuccess: onSuccess,
    onError: onError,
  });

  //------- Edit Charges in Table-------
  const setChargesFunction = async (values) =>
  {
    const body = new FormData();
    body.append("serviceCode", values.serviceCode);
    body.append("amount", values.amount);
    body.append("id", values.id);
    body.append("email", user.email);

    return await axios.post(
      `${Config.apiUrl}/updatecharges`,
      body,
      {
        headers: {
          authorization: user.token, //token is not in inspect
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );
  }

  const setChargesSuccess = (data) => {

    if (data?.data?.status == 'OK')
    {
      toast.success(data?.data?.msg || "Success");
      refetch();
    }
    else
    {
      toast.error(data?.data?.msg || "An Error Occured");
    }
    setSelectedData("");
    setOpenUpdateModel(false);
  };

  const setChargesError = (data) => {
    setOpenUpdateModel(false);
    setSelectedData("");
    toast.error(data?.data?.msg || "An Error Occured");

  };

  const { isLoading: setChargesLoading, mutate: setChargesMutate } = useMutation(
    setChargesFunction,
    {
      onSuccess: setChargesSuccess,
      onError: setChargesError,
    }
  );

  const SubmitHandler = async (values) => {
    //setChangePasswordModel(true);
    updateChargesMutate(values);
  };

  return (
    <>  
    <Navbar />
    <Page>
      <BoxContainer>
      <div className="flex w-full justify-between items-center">
        <div>
          <Title>Set Charges</Title>
          <Underline />
        </div>
      </div>

      {openUpdateModel && (
          <UpdateStatusModel
            postUpdateStatus={setChargesMutate}
            setOpenUpdateStatusModel={setOpenUpdateModel}
            editEntryLoading={setChargesLoading}
            //setEditUser={setEditUser}
            selectedData={selectedData}
          />
        )}

      <TableWrapper>
          <Table
            ApiData={error ? [] : data?.data?.data}
             setOpenUpdateModel={setOpenUpdateModel}
             setSelectedData={setSelectedData}
            // setEditUser={setEditUser}
            // setDeleteModel={setDeleteModel}

          />
        </TableWrapper>

        {/* <div className="mt-10">
          {(user.userType==2 ) && (<Formik initialValues={initialValues} onSubmit={SubmitHandler} enableReinitialize={isInitialValueSaved}>
            {
            (formikProps) => (
              <Form>
                <FormContainerVertical className=" w-full max-w-xl md:ml-10">
                <InputGroup>
                    <Label htmlFor="registerAssoc">REGISTERING ASSOCIATION Charges</Label>
                    <FieldWrapper>
                      <Field
                        name="registerAssoc"
                        type="number"
                        id="registerAssoc"
                        placeholder="Amount"
                        
                      />
                    </FieldWrapper>
                </InputGroup>
                    <InputGroup>
                      <Label htmlFor="correction">CORRECTIONS IN CONSTITUTION Charges</Label>
                      <FieldWrapper>
                        <Field
                          name="correction"
                          type="number"
                          id="correction"
                          placeholder="Amount"
                        />
                      </FieldWrapper>
                    </InputGroup>
                    <InputGroup>
                      <Label htmlFor="changeArticle">CHANGES IN ARTICLE Charges</Label>
                      <FieldWrapper>
                        <Field
                          name="changeArticle"
                          type="number"
                          id="changeArticle"
                          placeholder="Amount"
                        />
                      </FieldWrapper>
                    </InputGroup>
                  
                  <InputGroup>
                    <Label htmlFor="changeName">ASSOCIATION NAME CHANGING Charges</Label>
                    <FieldWrapper>
                      <Field
                        name="changeName"
                        type="number"
                        id="changeName"
                        placeholder="Amount"
                      />
                    </FieldWrapper>
                  </InputGroup>

                  <InputGroup>
                      <Label htmlFor="changeAddress">ASSOCIATION ADDRESS CHANGING Charges</Label>
                      <FieldWrapper>
                        <Field
                          name="changeAddress"
                          type="number"
                          id="changeAddress"
                          placeholder="Amount"
                        />
                      </FieldWrapper>
                    </InputGroup>
                  
                  <InputGroup>
                    <Label htmlFor="lostCertificate">ASSOCIATION LOST CERTIFICATE REISSUANCE Charges</Label>
                    <FieldWrapper>
                      <Field
                        name="lostCertificate"
                        type="number"
                        id="lostCertificate"
                        placeholder="Amount"
                      />
                    </FieldWrapper>
                  </InputGroup>
                  <InputGroup>
                    <Label htmlFor="annualFees">ASSOCIATION ANNUAL FEES</Label>
                    <FieldWrapper>
                      <Field
                        name="annualFees"
                        type="number"
                        id="annualFees"
                        placeholder="Amount"
                      />
                    </FieldWrapper>
                  </InputGroup>
                  <InputGroup>
                    <Label htmlFor="misc">MISC Charges</Label>
                    <FieldWrapper>
                      <Field
                        name="misc"
                        type="number"
                        id="misc"
                        placeholder="Amount"
                      />
                    </FieldWrapper>
                  </InputGroup>
                </FormContainerVertical>
                <SubmitBtnWrapper className="md:ml-10">
                <div className="flex items-center space-x-10">
                  <SubmitBtn type="submit" className="text-sm md:text-sm">
                    {t("Update")}
                  </SubmitBtn>
                </div>
                </SubmitBtnWrapper>
              </Form>
            )
            }
          </Formik>)}
        </div> */}
      </BoxContainer>
    </Page>
    </>
  );
};


const SingleItem = ({ name, value, link, url }) => (
  <div className="flex items-center py-2 border-b border-gray-100 ">
    <Name>{name}</Name> <p className="w-10">:</p>
    {link && (
      <LinkValue href={url} target="_blank" title="Click to open">
        {value}
      </LinkValue>
    )}
    {!link && <Value>{value}</Value>}
  </div>
);
const Uploader = ({ setChangePasswordModel }) => {
  const user = useSelector((state) => state.UserReducer.user);

  return (
    <UploadWrapper>
      {
        (user.userType==1) && (<Button type="button" onClick={() => setChangePasswordModel(true)}>
        <MdPassword className="text-white w-5 h-5" /> <p>Change Password</p>
      </Button>)}
      {/* <Button type="button" onClick={() => setOpenUploadModel(true)}>
        <HiUpload className="text-white w-5 h-5" /> <p>Upload Bulk Contact</p>
      </Button> */}
    </UploadWrapper>
  );
};

const TableWrapper = tw.h1`my-10 border   rounded-md overflow-auto`;

const SubmitBtnWrapper = tw.div`
mt-10 `;

const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;

const UploadWrapper = tw.div`
 w-full flex justify-end space-x-4 items-center `;

const Button = tw.button`text-white bg-teal-500 hover:bg-teal-600 w-40 flex items-center space-x-1 justify-center h-10   text-xs whitespace-nowrap rounded`;
const Wrapper = tw.div`px-4`;
const Name = tw.p`text-sm text-gray-500  w-40`;
const Value = tw.p`text-sm text-gray-800 font-medium max-w-xs `;
const LinkValue = tw.a`text-sm text-blue-500 max-w-xs truncate cursor-pointer`;

export default SetCharges;
